<template>
  <v-menu v-if="EXISTE_VENDA_FUTURA_COMPUTED" offset-y>
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="d-flex align-center ml-2">
        <v-divider vertical style="background: #484848" />
        <v-icon class="mr-n2 ml-3px">mdi-menu-down</v-icon>
      </div>
    </template>

    <div class="bg-white pt-1">
      <span class="font-12 text-gray-1100 px-2">
        <v-icon :size="18">mdi-menu</v-icon>
        Lista de opções
      </span>

      <v-divider />

      <v-list-item @click="adicionarNecessidadeMaisVendaFutura">
        <v-list-item-title>Adicionar a necessidade mais a venda futura de cada produto no carrinho</v-list-item-title>
      </v-list-item>
    </div>
  </v-menu>
</template>

<script setup>
import {validarVendaFutura} from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/utils";
import {computed} from "vue";

const props = defineProps({
  produtos: Array,
});

const emit = defineEmits(['adicionar']);

const EXISTE_VENDA_FUTURA_COMPUTED = computed(() => props.produtos.filter(item => Number(item.estoque_pendente) > 0).length > 0)

function adicionarNecessidadeMaisVendaFutura() {
  const produtos = props.produtos
    .map(item => ({
      ...item,
      sugestao: arredondarProLoteSuperior(item),
    })
  );
  emit('adicionar', produtos);
}

function formatarItemParaValidacao(item) {
  return {
    quantidade_compra: Number(item.sugestao),
    quantidade_sugestao: Number(item.sugestao_fixa),
    quantidade_venda_futura: Number(item.estoque_pendente),
  }
}

function arredondarProLoteSuperior(item) {
  let valor = Number(item.sugestao);

  if (!validarVendaFutura(formatarItemParaValidacao(item))) {
    valor += Number(item.estoque_pendente);
  }

  const lote_minimo = Number(item.lote_minimo || 0);
  return Math.ceil(valor / lote_minimo) * lote_minimo;
}
</script>
